'use strict';

define('vb/extensions/dynamic/private/models/context/layoutResourceExtensionBaseContext',[
  'vb/private/translations/translationContext',
], (
  TranslationContext,
) => {
  /**
   * BaseContext object used by LayoutResourceExtensions for $base in an expression.
   * It only exposes translations, for data-description-x, field-templates-x, metadata-rules-x, etc.
   */
  class LayoutResourceExtensionBaseContext {
    constructor(layoutResourceExtension) {
      const propDescriptors = {
        /**
         * $base.translations
         * This is what would be available in $translations in the base container.
         * This is a self updating property descriptor: the bundles context is loaded on the first get, and then
         * the property descriptor rewrites itself with that value so it doesn't have to be calculated again.
         */
        translations: TranslationContext.createTranslationsPropertyDescriptor(this, layoutResourceExtension.base),
      };

      Object.defineProperties(this, propDescriptors);
    }

    // Copied from src/vb/private/stateManagement/context/baseContext.js
    dispose() {
      // Delete every property because components sometime holding onto those properties preventing
      // the parent object from getting garbage collected.
      // eslint-disable-next-line guard-for-in, no-restricted-syntax
      for (const prop in this) { delete this[prop]; }
    }
  }

  return LayoutResourceExtensionBaseContext;
});

